<template lang="pug">
  .container
    .columns
      .column.is-8-desktop.is-8-tablet.has-text-centered
        .card
          .card-image
            br
            br
            figure.image.is-hidden-mobile
              img(src='../../assets/PatinEB00.png' alt='')
            figure.image.is-hidden-tablet
              img(src='../../assets/PatinEB00v.png' alt='')
            .card-content.is-overlay.is-clipped
              span.tag.is-dark
                | Patín PM100
          footer.card-footer
            a.card-footer-item
              | EB00
          span.valorItem#presion100 
            | PI-100: 
            b {{ parseFloat(pm100.presion).toFixed(2) }} &nbsp
            small kg/cm²
          span.valorItem#temperatura100 
            | TI-100: 
            b {{ parseFloat(pm100.temperatura).toFixed(2) }} &nbsp
            small °C
          span.valorItem#flujo100 
            | FI-100: 
            b {{ parseFloat(pm100.flujo).toFixed(2) }} &nbsp
            small Ton/hr
          span.valorItem#densidad100 
            | DI-100: 
            b {{ parseFloat(pm100.densidad).toFixed(1) }} &nbsp
            small kg/cm³
          span.valorItem#densidad20100 
            | DI-100_20: 
            b {{ parseFloat(pm100.densidad20).toFixed(1) }} &nbsp
            small kg/cm³
          span.valorItem#fqiG100 
            | FQIGross-100: 
            b {{ parseFloat(pm100.fqi_grossiv).toFixed(3) }} &nbsp
            small m³
          span.valorItem#fqiNet100 
            | FQInet-100: 
            b {{ parseFloat(pm100.fqi_netgsv).toFixed(3) }} &nbsp
            small m³
          span.valorItem#fqiMass100 
            | FQI-100: 
            b {{ parseFloat(pm100.fqi_mass).toFixed(3) }} &nbsp
            small Ton
      .column.is-4-desktop.is-4-tablet
        .card
          .card-content
            p.has-text-grey-dark Presión 
              b.has-text-dark {{ parseFloat(pm100.presion).toFixed(2) }}
            p.has-text-grey-dark Temperatura 
              b.has-text-dark {{ parseFloat(pm100.temperatura).toFixed(2) }}
            p.has-text-grey-dark Densidad 
              b.has-text-dark {{ parseFloat(pm100.densidad).toFixed(1) }}
            p.has-text-grey-dark Densidad Cor. 
              b.has-text-dark {{ parseFloat(pm100.densidad20).toFixed(1) }}
            p.has-text-grey-dark Flujo 
              b.has-text-dark {{ parseFloat(pm100.flujo).toFixed(2) }}
            p.has-text-grey-dark fqi grossiv 
              b.has-text-dark {{ parseFloat(pm100.fqi_grossiv).toFixed(3) }}
            p.has-text-grey-dark fql netgsv 
              b.has-text-dark {{ parseFloat(pm100.fqi_netgsv).toFixed(3) }}
            p.has-text-grey-dark fqi mass 
              b.has-text-dark {{ parseFloat(pm100.fqi_mass).toFixed(3) }}

        .card
          .card-content 
            .columns
              .column.is-6
                label.label Fecha de reporte:
                  .field
                    .control
                      flat-pickr(
                        v-model='fechaReporte'
                        :config="config"
                        class="input"
                      )
              .column.is-2.button-bottom
                a.button.is-black.is-rounded.is-small.mt-30.is-top(@click="descargarReporte")
                    i.fas.fa-print
                | &nbsp
</template>

<script>
import { mapState } from 'vuex'
import ductosServices from '@/services/ducto'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Spanish } from "flatpickr/dist/l10n/es.js"

export default {
  name: 'PatinPM100',
  components: { flatPickr },
  props: {
    activo: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      refresh: null,
      pm100: {},
      activarData: this.activo,
      fechaReporte: moment().format('YYYY-MM-DD'),
      config: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'Y-m-d',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: Spanish, // locale for this instance only          
      },
    }
  },
  watch: {
    activo(active) {
      this.activarData = active
      if (active) {
        this.iniciarComponente()
      } else {
        clearInterval(this.refresh)
      }
    }
  },
  methods: {
    descargarReporte(){
      const currentUrl = window.location.hostname
        let link = ''
        if (currentUrl === '10.122.40.189') {
          link = `http://${currentUrl}//servidores/reportes/monitoreo/patinpm100.php?fecha=${this.fechaReporte}`
        }
        else {
          link = `https://${currentUrl}//servidores/reportes/monitoreo/patinpm100.php?fecha=${this.fechaReporte}`
        }
        open(link, '_blank')
    },
    iniciarComponente() {
      this.refresh = setInterval(() => {
        if (this.activo) {
          this.obtenerDatosEB00()
        } else {
          clearInterval(this.refresh)
        }
      }, 5000)
    },
    obtenerDatosEB00() {
      ductosServices.getEB00()
        .then(data => {
          this.pm100 = data[0]
        })
    }
  },
  computed: {
    ...mapState(['logueado', 'userLogin'])
  },
  created() {
    this.obtenerDatosEB00()
    this.iniciarComponente()
  },
  beforeDestroy() {
    console.log('Antes de destruirse Patin PM-100')
    clearInterval(this.refresh)
    console.log(this.refresh)
  }
}
</script>

<style lang="css" scoped>
.image {
  display: inline-block;
}

#densidad100 {
  position: absolute;
  bottom: 90px;
  left: 330px;
}

#densidad20100 {
  position: absolute;
  bottom: 70px;
  left: 330px;
}

#presion100 {
  position: absolute;
  top: 95px;
  right: 285px;
}

#temperatura100 {
  position: absolute;
  top: 110px;
  right: 250px;
}

#flujo100 {
  position: absolute;
  top: 80px;
  right: 380px;
}

#fqiG100 {
  position: absolute;
  top: 10px;
  right: 10px;
}

#fqiNet100 {
  position: absolute;
  top: 30px;
  right: 10px;
}

#fqiMass100 {
  position: absolute;
  top: 50px;
  right: 10px;
}

.valorItem {
  font-weight: 600;
  color: #073592 !important;
}

@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {

  .valorItem {
    font-weight: 400;
    font-size: 14px;
    color: #073592 !important;
  }

  #densidad100 {
    position: absolute;
    bottom: 80px;
    left: 230px;
  }

  #densidad20100 {
    position: absolute;
    bottom: 60px;
    left: 220px;
  }

  #presion100 {
    position: absolute;
    top: 105px;
    right: 175px;
  }

  #temperatura100 {
    position: absolute;
    top: 120px;
    right: 140px;
  }

  #flujo100 {
    position: absolute;
    top: 90px;
    right: 270px;
  }

  #fqiG100 {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  #fqiNet100 {
    position: absolute;
    top: 30px;
    right: 10px;
  }

  #fqiMass100 {
    position: absolute;
    top: 50px;
    right: 10px;
  }
}

@media (min-width: 320px) and (max-width: 480px) {
  .valorItem {
    font-weight: 400;
    font-size: 12px;
    color: #073592 !important;
  }

  #densidad100 {
    left: auto;
    position: absolute;
    bottom: 350px;
    right: 10px;
  }

  #densidad20100 {
    left: auto;
    position: absolute;
    bottom: 290px;
    right: 10px;
  }

  #presion100 {
    position: absolute;
    top: 260px;
    right: auto;
    left: 10px;
  }

  #temperatura100 {
    position: absolute;
    top: 220px;
    right: auto;
    left: 10px;
  }

  #flujo100 {
    position: absolute;
    top: 360px;
    left: 5px;
    width: 120px;
    text-align: left;
  }

  #fqiG100 {
    position: absolute;
    top: 70px;
    right: 10px;
  }

  #fqiNet100 {
    position: absolute;
    top: 90px;
    right: 10px;
  }

  #fqiMass100 {
    position: absolute;
    top: 420px;
    left: 10px;
    text-align: left;
  }

  
}

.mt-30{
    margin-top: 30px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/estaciones_Componentes/PatinPM100.vue